import { Card, CardBody, Row, Col } from "reactstrap";
import React, { useCallback, useEffect, useState } from "react";
import VideoJS from "../component/common/video/videoJS.components";
import config from '../app/config';

const liveStreamingUrl = config.liveStreamingUrl;

export function LiveStreamingCard({ url }) {
  const [videoJsOptions, setVideoJsOptions] = useState(
    {
      autoplay: false,
      controls: true,
      responsive: true,
      fluid: true,
      poster: "/images/streaming_poster.jpg",
      sources: [{
        src: liveStreamingUrl,
        type: 'application/x-mpegURL'
      }]
    }
  )

  return (<Card>
    <CardBody>
      <Row>
        {/*Column SX*/}
        <Col md="7" sm="7" lg="7">
          <VideoJS options={videoJsOptions} />
        </Col>
      </Row>
    </CardBody>
  </Card>
  );
}
